import { createStore, useStore } from './store'

/**
 * The idea panel on a laptop: open beside the canvas, or folded to a strip
 * down its right edge so the canvas gets the width back without losing which
 * idea is open. Opening another idea unfolds it.
 */
export type PanelState = 'open' | 'collapsed'

export const panelStore = createStore<PanelState>('open')

export const usePanel = () => useStore(panelStore)
